import { load } from "cheerio";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import IndexedDBService, { storeName } from "../../Utils/DBConfig";
import { setIsDualLineMode } from "../../Slice/settingsSlice";
import fitty from "fitty";

const KirtanLinePlate = ({ reloadFlag }) => {
  const dispatch = useDispatch();

  const [currLine, setCurrLine] = useState("");

  const [nextLine, setNextLine] = useState("");

  const [fontSize, setFontSize] = useState(100);

  const [kirtanData, setKirtanData] = useState({});

  const kirtanId = useSelector((state) => state.kirtanIndex.kirtanId);

  const currIndex = useSelector((state) => state.kirtanIndex.currIndex);

  const isDualLineMode = useSelector((state) => state.settings.isDualLineMode);

  const shortcutIndex = useSelector((state) => state.kirtanIndex.shortcutIndex);

  const isDbInitialized = useSelector((state) => state.db.isDbInitialized);

  const searchFlag = useSelector((state) => state.kirtanIndex.searchFlag);

  const preSettings = useSelector((state) => state.settings.preSettings);

  const selectedId = useSelector((state) => state.settings.selectedId);

  const handleManualMode = async (line, fileName) => {
    let vmixSettings = localStorage.getItem("vmixSettings");
    if (vmixSettings) {
      vmixSettings = JSON.parse(vmixSettings);
      let func = "SetText";
      let url = `${vmixSettings.webControllerUrl}/api/?Function=${func}&Input=${vmixSettings.input}&Value=${encodeURIComponent(line)}&SelectedName=${encodeURIComponent(fileName)}`;
      try {
        const response = await fetch(url);
        if (response.ok) {
          return true;
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
    }
  };

  const stripHtml = (htmlString) => {
    const $ = load(htmlString);
    return $.text();
  };

  // function sendText(text) {
  //   const authToken = sessionStorage.getItem("token");

  //   fetch(`${APIurl}/api/kirtan/text`, {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json", Authorization: authToken ? `Bearer ${authToken}` : "" },
  //     body: JSON.stringify({ text }),
  //   });
  // }

  useEffect(() => {
    let index = currIndex;

    if (shortcutIndex !== null && shortcutIndex !== undefined) index = shortcutIndex;

    const currLine = kirtanData.length > 0 && kirtanData.find((kirtan) => kirtan.id === Number(kirtanId))?.content[index];

    const nextLine = kirtanData.length > 0 && isDualLineMode && kirtanData.find((kirtan) => kirtan.id === Number(kirtanId))?.content[index + 1];

    if (nextLine) setNextLine(nextLine);
    else setNextLine("");

    if (currLine) setCurrLine(currLine);
    // sendText(currLine);
  }, [currIndex, kirtanId, kirtanData, shortcutIndex, isDualLineMode, reloadFlag]);

  useEffect(() => {
    isDbInitialized && IndexedDBService.getAllData(storeName).then((data) => setKirtanData(data));
  }, [isDbInitialized, searchFlag, reloadFlag]);

  useEffect(() => {
    fitty("#current-line", {
      minSize: 12,
      maxSize: fontSize,
    });

    if (nextLine) {
      fitty("#next-line", {
        minSize: 12,
        maxSize: fontSize,
      });
    }
  }, [currLine, nextLine, fontSize, reloadFlag, isDbInitialized]);

  useEffect(() => {
    const latestFontSize = preSettings?.find((setting) => setting.id === selectedId)?.fontSize || "100px";
    setFontSize(+latestFontSize.slice(0, latestFontSize.length - 2));
  }, [selectedId, preSettings]);

  useEffect(() => {
    const matchingSetting = preSettings?.find((setting) => setting.id === selectedId);
    if (matchingSetting) {
      dispatch(setIsDualLineMode(matchingSetting.isDualLineMode));
    }
  }, [selectedId, preSettings, dispatch]);

  useEffect(() => {
    let manualMode = JSON.parse(localStorage.getItem("manualMode"));
    let vmixSettings = localStorage.getItem("vmixSettings");

    if (vmixSettings) {
      let settings = JSON.parse(vmixSettings);
      if (manualMode) {
        handleManualMode(stripHtml(currLine), settings.selectedName1);
        if (isDualLineMode && nextLine.trim().length > 0) handleManualMode(stripHtml(nextLine), settings.selectedName2);
      }
    }
  }, [currLine, isDualLineMode, nextLine]);

  // useEffect(() => {
  //   console.log('stripHtml(currLine);: ', stripHtml(currLine));
  //   console.log('sulekhToGujUnicodeConverter(stripHtml(currLine));: ', sulekhToGujUnicodeConverter(stripHtml(currLine)));
  // }, [currLine]);

  return (
    <div className="w-full">
      {preSettings?.map((setting) => {
        return (
          <div key={setting.id}>
            {setting.id === selectedId && (
              <div
                className="text-center border-black border flex items-center w-full justify-center"
                style={{
                  backgroundColor: setting.backgroundColor,
                }}
              >
                <div
                  className="text-center w-4/5 flex justify-center items-center flex-col no-select border-x-[1px] border-black border-solid border-opacity-25"
                  style={{
                    backgroundColor: setting.backgroundColor,
                    color: setting.color,
                    fontWeight: setting.fontWeight,
                    height: setting.height,
                    WebkitTextStroke: `${setting.textShadowWidth} ${setting.textShadowColor}`,
                  }}
                >
                  <div
                    id="current-line"
                    className={`h-full content-center px-5 ${setting.isDualLineMode ? "leading-none" : ""}`}
                    dangerouslySetInnerHTML={{
                      __html: currLine?.replace(
                        /(font-size\s*:\s*[^;]+;?|line-height\s*:\s*[^;]+;?|margin-left\s*:\s*[^;]+;?|margin-right\s*:\s*[^;]+;?|margin-bottom\s*:\s*[^;]+;?)/g,
                        ""
                      ),
                    }}
                  />

                  {setting.isDualLineMode && (
                    <div
                      id="next-line"
                      className={`h-full leading-none`}
                      dangerouslySetInnerHTML={{
                        __html: nextLine?.replace(
                          /(font-size\s*:\s*[^;]+;?|line-height\s*:\s*[^;]+;?|margin-left\s*:\s*[^;]+;?|margin-right\s*:\s*[^;]+;?|margin-bottom\s*:\s*[^;]+;?)/g,
                          ""
                        ),
                      }}
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default KirtanLinePlate;
